import React, { Component } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import CheckBox from '../CheckBox/CheckBox';

export class PPMarketingTerms extends Component {
    static propTypes = {
        termsCheckboxLabel: PropTypes.node.isRequired
    };

    render() {
        const { termsCheckboxLabel } = this.props;

        return (
            <div className="vx_col-md-12">
                <Field
                    id="marketing-terms"
                    name="marketingTerms"
                    label={termsCheckboxLabel}
                    component={CheckBox}
                    alignLabelTop={true}
                />
            </div>
        );
    }
}
export default PPMarketingTerms;
